module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		simpleSubForm: true
	},

	events: {
		change: function(event){
			event.stopImmediatePropagation();
			var self = event.data.component;

			var $target, fieldCode, value;
			if(($target = $(event.target)).length > 0 && (fieldCode = $target.data('fieldCode')) && (value = $target.val())){
				self.childChanged({
					fieldCode: fieldCode,
					value: value
				});
			}
		},

		click: {
			type: 'click',
			selector: 'button[data-field-type="delete"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var data = self.resourceData.data || {};
				var attributes = data.attributes || {};
				var primaryKey = attributes[data.primaryKey || 0];

				if(primaryKey){
					self.resourceData.data.type = 'delete';
					self.model.isReadyToDelete = true;
					self.$.addClass('isReadyToDelete');
					self.triggerClosest('onChildChanged', {
						dataIndex: self.model.dataIndex,
						data: self.resourceData.data
					});
				} else {
					self.triggerClosest('onChildChanged', {
						dataIndex: self.model.dataIndex,
						data: null
					});
					self.destroy();
				}
			}
		}
	},

	methods: {
		childChanged: function(valueDefinition, init){
			if(this.config.isReady){
				this.resourceData.data = this.resourceData.data || {};
				this.resourceData.data.attributes = this.resourceData.data.attributes || {};

				if(valueDefinition.fieldCode){
					this.resourceData.data.attributes[valueDefinition.fieldCode] = valueDefinition.value;

					if(valueDefinition.fieldCode === 'segmentationField'){
						this.triggerFind('segmentationFieldChanged', {
							fieldName: valueDefinition.value
						});
					}
				}

				if(valueDefinition.fieldCode) this.processValidation(valueDefinition.fieldCode)

				this.triggerClosest('onChildChanged', {
					dataIndex: this.model.dataIndex,
					data: this.resourceData.data
				});
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var attributes = (this.resourceData.data || {}).attributes || {};
			var segmentationField = attributes.segmentationField;
			var segmentationValue = attributes.segmentationValue;
			if(!(options || {}).refresh && segmentationField){
				this.triggerFind('segmentationFieldChanged', {
					fieldName: 	segmentationField,
					fieldValue: segmentationValue
				});
			}
		},

		fieldNameUpdated: function($element, options){
			$element.removeClass('isLoading');
		},

		onChildChanged: function($element, options){
			this.childChanged(options);
		}
	}
}